"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var suffixes = ['', 'k', 'M', 'B', 'T', ''];
/**
 * Abbreviate number to SI units
 * @example 10 => 10
 * @example 1000 => 1k
 * @example 1000000 => 1M
 */
var abbreviateNumber = function (value) {
    // Log will error out on 0 so just return 0 back
    if (!value || (value < 1 && value > -1)) {
        return lodash_1.isNumber(value) ? value.toString() : null;
    }
    // Determine the level of rounding that is needed
    var tier = Math.floor(Math.log(Math.abs(value)) / Math.log(1000));
    // Get suffix associated with value
    var suffix = suffixes[Math.min(tier, suffixes.length)];
    // Adjust value to be rounded to correct tier
    var adjusted = String(Math.abs(value) / Math.pow(1000, tier)).substring(0, 3);
    // Remove trailing decimal if exists
    var noTrailingDec = adjusted.endsWith('.')
        ? adjusted.slice(0, -1)
        : adjusted;
    // Format value for return (negative? value suffix)
    return "" + (value < 0 ? '-' : '') + noTrailingDec + suffix;
};
exports.default = abbreviateNumber;
